var BlockView = require('views/block/base-block-view');
var FeedbackService = require('services/feedback-service');
import { KeybindingService, keys } from 'services/keybinding-service';
var LocaleService = require('services/locale-service');
const AhoyService = require('services/ahoy-service');

const { ArrowDown, ArrowUp, ArrowLeft, ArrowRight, Enter, Space, Home, End, PageUp, PageDown, AnyMatched } = keys;

var SliderView = BlockView.extend({
  className: 'sliders',
  load: function() {
    this.value = 0;
    this.moving = false;
    this.required = 0;
    
    this.model.get('sliders').forEach(slider => this.setupSlider(slider));
 
    this.delegate('change input', 'input', function(e) {
      e.preventDefault();
      var slider = this.findSlider($(e.currentTarget).parent().attr('data-subject'));
      var selectedPoint = slider.points[e.currentTarget.valueAsNumber];
      if(!selectedPoint) { console.error('Your step setting seems to exceed the amount of points set up in your yml.'); return false; }      
      if(slider.required && slider.visitAllPoints) {
        if(slider.visited && (e.currentTarget.valueAsNumber !== slider.visited[slider.visited.length-1]) ) {
            let val;
            if(selectedPoint.index > (slider.visited.length-1)) { // clicked/dragged to the right of current loc
              val = slider.points[slider.visited.length] ? slider.points[slider.visited.length].value : slider.points[slider.points.length-1].value;
            } else if(selectedPoint.index < (slider.visited.length-1)) { // clicked/dragged to the left of current loc
              val = slider.points[slider.visited.length-2] ? slider.points[slider.visited.length-2].value : slider.points[0].value;
              slider.visited.splice(-1,1);
            }
            if(val) {
              selectedPoint = this.getClosestByValue(slider.points, val);
              this.changeValue(slider, selectedPoint);
            }
        }
      } else {
        this.changeValue(slider, selectedPoint);
      }
      toggle.call(this, slider);
    });    
    const toggle = function(slider) {
      const currentSlider = this.model.get('sliders').find(({subject}) => subject === slider.subject);
      if(slider.currentPoint.value <= currentSlider.min) {
        this.$el.find('.slider-step.minus').attr('disabled', 'disabled');
      }
      if(slider.currentPoint.value > currentSlider.min) {
        this.$el.find('.slider-step.minus').removeAttr('disabled');
      }
      if(slider.currentPoint.value >= currentSlider.max) {
        this.$el.find('.slider-step.plus').attr('disabled', 'disabled');
      }
      if(slider.currentPoint.value < currentSlider.max) {
        this.$el.find('.slider-step.plus').removeAttr('disabled');
      }
    };   
    
    // Increment && Decrement Events
    const handleSliderChange = (e, slider, target) => {
      if(target.attr('data-change') === 'decrement' && slider.currentPoint.index > 0) {
        e.preventDefault();
        this.startChanging(slider);
        $('.slider-step.minus').attr('aria-label', LocaleService.t('slider.decrementBtn') + ' ' + (slider.value - slider.step));         
      } else if(target.attr('data-change') === 'increment' && slider.currentPoint.index < slider.points.length) {
        e.preventDefault();
        this.startChanging(slider, true);
        $('.slider-step.plus').attr('aria-label', LocaleService.t('slider.incrementBtn') + ' ' + (slider.value + slider.step));       
      }
      toggle.call(this, slider);
    }
    this.delegate('mousedown touchstart', '.slider-step', function(e) {      
      e.stopPropagation();
      const target = $(e.currentTarget);
      const slider = this.findSlider(target.attr('data-subject'));
      if(slider.enable_step_buttons) {        
        handleSliderChange(e, slider, target);
      }
    });
    this.delegate('keyup', '.slider-step', function(e) {      
      e.stopPropagation();
      const target = $(e.currentTarget);
      const slider = this.findSlider(target.attr('data-subject'));
      if(slider.enable_step_buttons && event.keyCode === 13) {        
        handleSliderChange(e, slider, target);
      }
    });
  },
  setupSlider: function(slider) {
    slider.element = $(`#${this.model.get('cid')}-${slider.subject}`);
    slider.input = slider.element.find('input');

    slider.element.css({
      '-webkit-touch-callout': 'none',
      '-webkit-user-select': 'none',
      '-khtml-user-select': 'none',
      '-moz-user-select': 'none',
      '-ms-user-select': 'none',
      'user-select': 'none'
    });
    
    if(typeof slider.points === 'number') {
      slider.points =  [...Array(++slider.points)].map((_,e) => {
        return {index: e};
      });
    }

    if(slider.required) {
      this.required++;
    }

    slider.value = slider.value || slider.min;
    this.initAttributes(slider);
    this.updateAria(slider);

    if(slider.show_button_value) {
      if(slider.output_class) {
        $('.' + slider.output_class).text(slider.value);
      } else {
        $(slider.input).parent().append('<span class="feedbackBubble" style="position:absolute;">' + slider.value + '</span>');
      }
    }
  },
  initAttributes: function(slider) {
      $(slider.input).attr({'max': (slider.max - slider.min) / slider.step});
  },
  updateAria: function(slider) {
      $(slider.input).attr({
          'data-percent': slider.value * 100 / slider.max,
          'data-state': slider.value,
          'data-ratio': slider.value / slider.step
      });
  },
  startChanging: function(slider, increment) {
    let selectedPoint;
    if(increment) {
      selectedPoint = slider.points[slider.currentPoint.index+1] ? slider.points[slider.currentPoint.index+1] : slider.points[slider.points.length-1];
    } else {
      selectedPoint = slider.points[slider.currentPoint.index - 1] ? slider.points[slider.currentPoint.index - 1] : slider.points[0];
    }
    this.changeValue(slider, selectedPoint);
  },
  handleFeedbackOutput: function(slider, selectedPoint) {
      const size = slider.vertical ? slider.element.height() : slider.element.width();
      const value = slider.input.val(); // this value should be something between 0 and the max="" on the element, not the min/max in the yml
      const bubble = slider.element.parent().find('span.feedbackBubble');
      const horizontalThumb = slider.element.parent().find('.slider-thumb-horizontal');
      const verticalThumb = slider.element.parent().find('.slider-thumb-vertical');
      const thumbSize = slider.vertical ? verticalThumb.height() : horizontalThumb.width();

      const newPoint = (selectedPoint.value - slider.min) / (slider.max - slider.min);
      let offset = 0; // because <input slide=range is inaccurate\
      let newPlace;

      if(newPoint < 0) {
        newPlace = 0;
      } else if(newPoint > 1) {
        newPlace = size - thumbSize;
      }
      else {
        newPlace = size * newPoint + offset;
        newPlace = newPlace === size ? newPlace - thumbSize : newPlace;
        offset -= newPoint * -(offset*3);
      }

      const val = (value * slider.step) + slider.min;

      if(bubble && slider.vertical) {
        bubble.css({ bottom: newPlace, marginBottom: `${offset}%`}).text(val);
      } else if(bubble) {
        bubble.css({left: newPlace, marginLeft: `${offset}%`}).text(val);
      }

      if(slider.vertical) {
        verticalThumb.css({
          bottom: newPlace,
          marginBottom: `${offset}%`
        });
      } else {
        horizontalThumb.css({
          left: newPlace,
          marginLeft: `${offset}%`
        });
      }
  },
  play: function() {
    var sliders = this.model.get('sliders');
    var setSliderData = _.bind(this.setSliderData, this);
    var resizeHandler = _.debounce(setSliderData, 200);
    _.each(sliders, function(slider) {
      setSliderData(slider, true);
    });
    window.addEventListener('resize', function() {
      _.each(sliders, function(slider) {
        resizeHandler(slider);
      });
    });
    if(this.required === 0) {
      this.readyToGo();
    }
  },
  dispose: function() {
    BlockView.prototype.dispose.apply(this, arguments);
  },
  findSlider: function(subject) {
    var slider = _(this.model.get('sliders')).find(function(slider) {
      return slider.subject === subject;
    });
    return slider;
  },
  getClosestByValue: function(arr, val) {
    if(val < 0.1) return arr[0];
    return arr.reduce(function(prev, curr) {
      if(prev.value) {
        return (Math.abs(curr.value - val) < Math.abs(prev.value - val) ? curr : prev);
      } else {
        return curr;
      }
    });
  },
  setSliderData: function(slider, initialize) {
    slider.element = this.$('.slider[data-subject="' + slider.subject + '"]');
    slider.input = slider.element.find('input');

    var leftMost = slider.left || 0;
    var rightMost = slider.right || slider.element.width();
    var step = rightMost / slider.points.length;
    var position = leftMost;
    var value = slider.min;

    slider.points.forEach(function(point, index) {
      point.position = position;
      point.value = point.value || value;
      point.index = index;
      value = point.value + slider.step;
      position += (step + ( step / slider.points.length));
    });

    //code for sliders and condition added to check undefined behaviour for slider value
    var matchedSliderPoint = _.find(slider.points, function(e) {
      return e.value === slider.value;
    });
    if(matchedSliderPoint === undefined) matchedSliderPoint = slider.points[0];
    if(initialize) {
      this.changeValue(slider, matchedSliderPoint);
    } else {
      this.changeValue(slider, slider.currentPoint);
    }
  },
  changeValue: function(slider, selectedPoint) {
      slider.input.attr({
        'data-state': selectedPoint.value
      });
      this.updateAria(slider);
      if(selectedPoint.description) {
        slider.input.attr('aria-valuetext', LocaleService.t(selectedPoint.description));
      }
      slider.currentPoint = selectedPoint;
      slider.visited = slider.visited || [];
      $(slider.input).val(selectedPoint.index);
      slider.value = selectedPoint.value;
      if(!_.includes(slider.visited, selectedPoint.value)) {
        slider.visited.push(selectedPoint.value);
      }
      var values = {};
      _.each(this.model.get('sliders'), function(slider) {
        values[slider.subject] = slider.value;
      });
      if(slider.show_button_value) {
        if(slider.output_class) {
          this.handleFeedbackOutput(slider, selectedPoint);
          $('.' + slider.output_class).text(slider.value);
        } else {
          this.handleFeedbackOutput(slider, selectedPoint);
        }
        slider.input.trigger('valuechanged', slider.value);
      }
      AhoyService.track('slider', {action: 'move', subject: slider.subject, value: slider.value});

      var feedback = FeedbackService.matchFeedback(this.model.get('feedbacks'), values);
      FeedbackService.renderFeedbackWithElementState(feedback, slider.element, 'correct', [ 'correct' ]);
      Chaplin.mediator.publish('block:values:change', values, this, this.pageView);
      this.checkComplete();
  },
  _increment: function(slider, direction) {
    this.changeValue(slider, slider.points[slider.currentPoint.index + direction]);
  },
  checkComplete: function() {
    if(this.model.get('state') === 'completed') {
      return;
    }
    var required_completed = 0;
    _.each(this.model.get('sliders'), function(slider) {
      if(slider.required) {
        if(slider.visited) {
          var amountRequired = (slider.visitAllPoints) ? slider.points.length : 2;
          if(slider.visited.length >= amountRequired) {
            required_completed++;
          }
        }
      }
    });
    if(this.required !== 0 && required_completed === this.required) {
      AhoyService.track('slider', {action: 'completed'});
      this.readyToGo();
    }
  }
});

module.exports = SliderView;
